module.exports = __webpack_public_path__ + "static/media/5-cant-get-me.b1ef70e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/5-cant-get-me.mp3
// module id = bPng
// module chunks = 0